<template>
    <div class="d-flex flex-column">
<!--         <div>
            <p v-html="$t('general.welcomeText')"></p>
        </div> -->
        <system-select ref="systemSelectDiv" id="systemSelectDiv" @onSelectedChange="checkSystemSelect" :systemSolutions="systemSolutions"  />

        <section v-if="systemIsSelect" class="z-20">
            <application-controller-select ref="applicationControllerDiv" id="applicationControllerDiv" :selectedSystem="selectedSystem" @onSelectedChange="checkApplicationControllerSelect" @onChange="onDeviceListChange" />

        </section>
        <section class="position-static" v-if="systemIsSelect && applicationControllerIsSelect">
          
            <bus-devices-list ref="busDeviesListDiv" id="busDeviesListDiv"  @onChange="onDeviceListChange" :calculation-result="result" />

            <result-overview  @onChange="onDeviceListChange" :result="result" />
            <action-bar @resetPlanning="resetPlanning" />

        </section>
    </div>
</template>

<script>
import SystemSelect from '../components/System/SystemSelect.vue'
import ApplicationControllerSelect from '../components/ApplicationController/ApplicationControllerSelect.vue'
import BusDevicesList from '@/components/BusDevices/BusDevicesList.vue';
import ResultOverview from '@/components/Result/ResultOverview.vue';

import ActionBar from '../components/Project/ActionBar.vue';
import deviceCalculation from '@/assets/js/deviceCalculation';
import {mapGetters} from 'vuex';
import helper from '@/assets/js/helperTool';

export default {
    name: "HomeView",
    data() {
        return {
            systemSolutions: [
                        {
                            id: 1,
                            name: this.$t('daliSolution.compactSensor.name'),
                            icon: 'fa-kit fa-beg-logo-daco',
                            systemType: 'compactSensor',
                            active: false
                        },
/*                         {
                            id: 2,
                            name: 'Kompaktsensor <br> Multimaster',
                            icon: 'fa-solid fa-people-group fa-4x',
                            active: false
                        }, */
                        {
                            id: 3,
                            name:  this.$t('daliSolution.casambi.name'),
                          icon: 'fa-kit fa-beg-casambi',
                          systemType: 'casambi',
                            active: false
                        },
                        {
                            id: 4,
                            name: this.$t('daliSolution.daliLink.name'),
                            icon: 'fa-kit fa-beg-logo-dali-link',
                            //icon: 'fa-solid fa-link fa-4x',
                            systemType: 'daliLink',
                            active: false
                        },
                        {
                            id: 5,
                            icon: 'fa-kit fa-beg-logo-knx',
                            name:  this.$t('daliSolution.knx.name'),
                            systemType: 'knx',
                            active: false
                        },
                        {
                            id: 6,
                            icon: "fa-kit fa-beg-bms-logo",
                            name: this.$t('daliSolution.bms.name'),
                            systemType: 'bms',
                            active: false
                        }   
                    ],
            systemIsSelect: false,
            selectedSystem: null,
            applicationControllerIsSelect: false,
            result: null
        }
    },
    mounted() {

    },
    methods: {
        checkSystemSelect(element, allElements) {
            this.selectedSystem = element
            this.allSystemSolution = allElements
            if(element != null) {
                this.systemIsSelect = true
            } else {
                this.systemIsSelect = false
            }
            this.$store.dispatch('product/selectApplicationController',{})
        },
        checkApplicationControllerSelect(element) {
            if(element != null) {
                this.applicationControllerIsSelect = true
                this.onDeviceListChange();
            } else {
                this.applicationControllerIsSelect = false
                this.onDeviceListChange();
            }
        },
        onDeviceListChange() {
            let allBusDevices = helper.cloneItem(this.busDevices);
            for(let device of this.busMajorDevices) {
                allBusDevices.push(device)
            }
            deviceCalculation.calculateNow(this.selectedApplicationController,allBusDevices)
            this.result = deviceCalculation.getResult();
            const own = this;
            setTimeout(() => {
                let allBusDevices = helper.cloneItem(this.busDevices);
                for(let device of this.busMajorDevices) {
                    allBusDevices.push(device)
                }
                deviceCalculation.calculateNow(this.selectedApplicationController,allBusDevices)
                own.result = deviceCalculation.getResult();
                const payload = {};
                payload.calculationResult = this.result
                payload.selectedApplicationController = this.selectedApplicationController
                this.$store.dispatch('busDevice/createMajorProducts', payload)
            }, 200)

        },
        resetPlanning() {
            this.systemIsSelect = false
            this.selectedSystem = null,
            this.applicationControllerIsSelect= false
            this.result = null
            this.$store.dispatch('product/resetApplicationController')
            this.checkSystemSelect(null)
            for(let systemSolution of this.systemSolutions) {
                systemSolution.active = false
            }
        }
    },
    computed: {
        ...mapGetters({
            busDevices: 'busDevice/getAllItems',
            busMajorDevices: 'busDevice/getAllMajorItems',
            selectedApplicationController: 'product/getSelectedApplicationController'
        }),
    },
    watch: {
        systemIsSelect(newValue) {
            newValue
            this.$nextTick(() => {
                let element = document.getElementById('applicationControllerDiv');
                const rect = element.getBoundingClientRect();
                //let bodyElement = document.body.getBoundingClientRect()

                //window.location.href = "#applicationControllerDiv";
                if(newValue === true) {
/*                     location.href = "#";
                    location.href = "#applicationControllerDiv"; */
                    window.scroll({
                        top: rect.top + window.scrollY - 186,
                        behavior: 'smooth'
                    })
                }
            })
        },
        applicationControllerIsSelect(newValue) {
            this.$nextTick(() => {
                let element = document.getElementById('busDeviesListDiv');
                const rect = element.getBoundingClientRect();
                if((newValue === true) && (this.selectedApplicationController.productNo != "00000")) {
                    window.scroll({
                        top:  rect.top + window.scrollY - 600,
                        behavior: 'smooth'
                    })
                }
            })
        }
    },
    components: {
    SystemSelect,
    ApplicationControllerSelect,
    BusDevicesList,
    ResultOverview,
    ActionBar
}
}
</script>

<style lang="scss" scoped>
    .iconInButton {
        display: inline-block;
        height: 15px;
        vertical-align: middle;
    }

    .z-20 {
        position: relative;
        z-index: 20;
    }

    .z-50 {
        position: relative;
        z-index: 50;
    }
</style>